var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modalContainer"},[_c('div',{staticClass:"modalOpenTarget",on:{"click":function (){this$1.modalOpen = true}}},[_vm._t("modalOpenContent",[_vm._v("Open")])],2),_c('transition',{attrs:{"name":"modal-fade"}},[(_vm.modalOpen)?_c('Modal',{on:{"close":_vm.closeModal}},[_vm._t("modalContent",[_vm._v("\n        No Content\n      ")])],2):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }